import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const SegmentedControlRadioGroup = styled(RadixRadioGroup.Root)`
    height: 32px;
    padding: ${theme.space[4]};
    background-color: ${theme.colors.background.inset};
    border-radius: ${theme.radii[8]};
    width: max-content;
`;
